export default __webpack_public_path__ + "static/media/email-monitoring.c78aebd7.png";